/** Hand a URL to whatever the operating system considers the browser. */
export function openBrowser(url: string): void {
  // eslint-disable-next-line @typescript-eslint/consistent-type-imports
  const { exec } = require('child_process') as typeof import('child_process')

  const command = process.platform === 'darwin'
    ? `open "${ url }"`
    : process.platform === 'win32'
      ? `start "${ url }"`
      : `xdg-open "${ url }"`

  // Detached from this process's lifetime: whether the browser is still open has nothing to do with whether
  // the CLI is finished, and an unreaped child handle would keep it running.
  exec(command).unref()
}
